import React from "react";
import { FormattedMessage, FormattedHTMLMessage } from "react-intl";

import { Image, Flex, Content } from "./styles";
import messages from "./messages";

const ShortcutsModal = () => (
    <>
        <Image src="/images/score/score-editor-keyboard-v2.svg" />
        <Content>
            <p>
                <FormattedMessage {...messages.p1} />
            </p>
            <Flex>
                <div>
                    <FormattedHTMLMessage {...messages.pitch} />
                </div>
                <div>
                    <FormattedHTMLMessage {...messages.rhythm} />
                </div>
            </Flex>
            <p>
                <FormattedMessage {...messages.p2} />
            </p>
        </Content>
    </>
);

export default ShortcutsModal;
